import React, { useState } from 'react';
import { useSelector } from 'react-redux';
import PropTypes from 'prop-types';
import { Button } from 'react-bootstrap';
import { getCloseOrderTracker, setCloseOrderTracker } from 'app/utilities/Storage';
import { buttonEventClick } from 'clevertap/LogEvent';
import Svg from '../../common/Svg';
import { Constants } from '../../../utilities';
import style from './index.module.scss';

const OrderTracking = (props) => {
  const { history, language, page } = props;
  const { activeOrders } = useSelector((state) => state.main);
  const [isOrderTrackerClosed, setIsOrderTrackerClosed] = useState(!!getCloseOrderTracker());

  function getSvgType(status) {
    switch (status) {
      case 'Order Placed': return 'orderPlaced';
      case 'Order Accepted': return 'orderAccepted';
      case 'Order on its way': return 'orderOnTheWay';
      case 'Order Ready for Pickup': return 'orderPickUp';
      case 'Order Modified': return 'orderModified';
      case 'Payment Required': return 'paymentPending';
      default: return 'orderPlaced';
    }
  }

  const orderTrackerDiv = (order, bgColor = '#E5F9E2', isButton = true) => (
    <div className={style.order_tracking_wrapper} style={{ backgroundColor: bgColor }}>
      <div className="d-flex align-items-center justify-content-between">
        <div className="d-flex align-items-center">
          <div>
            <Svg
              svg={getSvgType(order.statusText)}
              width={24}
              height={24}
            />
          </div>
          <div className="ml-3">
            <div className={style.line_height_20}>
              <div className="fs-6 text-truncate-1">
                {order.storeName}
              </div>
              <div className="fs-4 font-weight-bold">
                {order.statusText}
              </div>
              <div className="fs-5">
                {order.statusDescription}
              </div>
            </div>
          </div>
        </div>
        {
          !isButton ? (
            <div className="d-flex align-items-center">
              <div className="px-2">
                <div className={style.left_border} />
              </div>
              <button
                type="button"
                className="r__category_thumb p-0"
                onClick={() => {
                  buttonEventClick(
                    'Order Tracking Button Click',
                    {
                      Page: page,
                      'Order Status': order.statusText,
                    },
                  );
                  history.push(`/orders/${order.orderId}`);
                }}
              >
                <span className={`${style.line_height_20} text-primary fs-4 font-weight-bold mr-n1`}>
                  {Constants.String.REVIEW_ORDER[language]}
                </span>
              </button>
              <button
                type="button"
                className="r__category_thumb p-0"
                onClick={() => {
                  buttonEventClick(
                    'Order Tracking Button Click',
                    {
                      Page: page,
                      'Order Status': order.statusText,
                    },
                  );
                  history.push(`/orders/${order.orderId}`);
                }}
              >
                <Svg
                  svg="fillArrow"
                  width={24}
                  height={24}
                  fill="#B8238E"
                />
              </button>
            </div>
          ) : (
            <div>
              <Button
                variant="link"
                className="p-0"
                onClick={() => {
                  buttonEventClick(
                    'Order Tracking Button Click',
                    {
                      Page: page,
                      'Order Status': order.statusText,
                    },
                  );
                  history.push(`/orders/${order.orderId}`);
                }}
              >
                <Svg
                  svg="fillArrow"
                  width={24}
                  height={24}
                  fill="#000"
                />
              </Button>
            </div>
          )
        }
      </div>
      {
        isButton && (
          <div className="mt-1">
            <Button
              block
              className={`${style.dismiss_button} fs-5`}
              onClick={() => {
                setIsOrderTrackerClosed(true);
                setCloseOrderTracker(new Date().getTime());
              }}
            >
              {Constants.String.DISMISS_ORDER_TRACKER[language]}
            </Button>
          </div>
        )
      }
    </div>
  );

  return (
    <>
      {
        !isOrderTrackerClosed && activeOrders && (
          <>
            {(() => {
              let showcase = null;
              if (
                activeOrders.pendingPaymentOrders && activeOrders.pendingPaymentOrders.length > 0
              ) {
                showcase = (orderTrackerDiv(activeOrders.pendingPaymentOrders[0], '#FFE9F9', false));
              } else if (
                activeOrders.modifiedOrders && activeOrders.modifiedOrders.length > 0
              ) {
                showcase = (orderTrackerDiv(activeOrders.modifiedOrders[0], '#FFE9F9', false));
              } else if (
                activeOrders.inProgressOrders && activeOrders.inProgressOrders.length > 0
              ) {
                showcase = (orderTrackerDiv(activeOrders.inProgressOrders[0], '#E5F9E2', true));
              } else if (
                activeOrders.disputableDeliveredOrders
                && activeOrders.disputableDeliveredOrders.length > 0
              ) {
                // TODO document why this block is empty
              }
              return showcase;
            })()}
          </>
        )
      }
    </>
  );
};

OrderTracking.propTypes = {
  history: PropTypes.shape({
    push: PropTypes.func,
  }).isRequired,
  language: PropTypes.string.isRequired,
  page: PropTypes.string.isRequired,
};

export default OrderTracking;
